import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import '@assets/services/datePrototype';
import '@assets/services/prototypes';
bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
